import HistoryContext from '@/contexts/History/History.context';
import { useContext } from 'react';

const useLastUrl = () => {
  const context = useContext(HistoryContext);

  if (context === undefined) {
    throw new Error('useLastUrl must be used within a HistoryContext provider');
  }

  const getLastUrl = (predicate?: (url: string) => boolean) => {
    if (context.history.length <= 1) {
      return undefined;
    }

    // The first element is the current route and thus should be ignored.
    const [, ...history] = [...context.history].reverse();

    if (!predicate) {
      return history[0];
    } else {
      return history.find(predicate);
    }
  };

  return {
    getLastUrl,
  };
};

export default useLastUrl;
